import views from 'anonymous/views';
import paths from './paths';

const accessGranted = (): boolean => true;

export const APP_HOME = {
  isPrivate: false,
  accessGranted,
  component: views.AppHome,
  path: paths.APP_HOME,
  title: ''
};

export const LOGIN = {
  isPrivate: false,
  accessGranted,
  component: views.Login,
  path: paths.LOGIN,
  title: 'Login'
};

export const REGISTER = {
  isPrivate: false,
  accessGranted,
  component: views.Register,
  path: paths.REGISTER,
  title: 'Registro'
};

export const CONFIRM_EMAIL = {
  isPrivate: false,
  accessGranted,
  component: views.ConfirmEmail,
  path: paths.CONFIRM_EMAIL,
  title: 'Confirmar email'
};

export const ADMIN_CONFIRM_EMAIL = {
  isPrivate: false,
  accessGranted,
  component: views.AdminConfirmEmail,
  path: paths.ADMIN_CONFIRM_EMAIL,
  title: 'Confirmar email'
};

export const RECOVER_PASSWORD = {
  isPrivate: false,
  accessGranted,
  component: views.RecoverPassword,
  path: paths.RECOVER_PASSWORD,
  title: 'Recuperar contraseña'
};

export const RESET_PASSWORD = {
  isPrivate: false,
  accessGranted,
  component: views.ResetPassword,
  path: paths.RESET_PASSWORD,
  title: 'Restablecer contraseña'
};

export const LEGAL = {
  isPrivate: false,
  accessGranted,
  component: views.Legal,
  path: paths.LEGAL,
  title: 'Páginas legales'
};

const routes = [
  ADMIN_CONFIRM_EMAIL,
  CONFIRM_EMAIL,
  REGISTER,
  RECOVER_PASSWORD,
  RESET_PASSWORD,
  LOGIN,
  APP_HOME,
  LEGAL
];

export default routes;
